import styled from "styled-components";

import { Code } from "@components";

import { StepItemProps } from "@pages/setup/types";

const StepNumber = styled.div`
  color: var(--indigo1);
  font-weight: var(--global-font-weight-bold);
  font-size: var(--global-font-size-m);

  // draw circle (need fixed height and width)
  border: 2px solid var(--indigo1);
  border-radius: 50%;
  width: calc(var(--global-font-size-m) + 16px);
  height: calc(var(--global-font-size-m) + 16px);
  flex-shrink: 0; // no shrinking

  // center number
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StepTitle = styled.div`
  font-size: var(--global-font-size-l);
  color: var(--dark-gray1);
`;

const StepContainer = styled.div`
  color: var(--global-mid-gray);
  display: flex;
  width: 100%;
  gap: 16px;
`;

const StepContent = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
`;

export const StepItem: React.FC<StepItemProps> = ({
  number,
  title,
  command,
  description,
  button,
  bottomDescription,
}) => {
  return (
    <StepContainer>
      <StepNumber>{number}</StepNumber>
      <StepContent>
        <StepTitle>{title}</StepTitle>
        {command && (
          <Code light copyable>
            {command}
          </Code>
        )}
        <>{description}</>
        {button && <>{button}</>}
        {bottomDescription && <>{bottomDescription}</>}
      </StepContent>
    </StepContainer>
  );
};
